import css from '@styled-system/css';
import { Stack, WithIcon } from '../../shared/layouts';
import Box from '../../shared/layouts/Box';
import Flex from '../../shared/layouts/Flex';
import OpenSvg from 'imagesUwKluis/svg/open.svg';
import styled from '@emotion/styled';
import useIconLibrary from '../../../hooks/useIconLibrary';
import { useNavigate } from 'react-router-dom';

const RowContainer = styled(Flex)(({ theme }) => ({
  maxWidth: 1024,
  minHeight: 80,
  alignItems: 'center',
  borderRadius: theme.borderRadius,
  boxShadow: theme.boxShadows.normal,
  cursor: 'pointer',
  justifyContent: 'space-between',
}));

export default ({ product }) => {
  const { DocumentsIcon } = useIconLibrary();
  const navigate = useNavigate();

  return (
    <RowContainer bg="white" px="l" py="m" onClick={() => navigate(`/products/insurances/${product.type}/${product.id}`)}>
      <WithIcon space="m" color="primary">
        <DocumentsIcon width="2rem" height="2rem" />
        <Stack space="xs">
          <Box fontWeight="bold" lineHeight={'1.25rem'}>
            Pakketpolis - {product.description}
          </Box>
          {product.package_number !== null && (<Box>Pakketnr. {product.package_number}</Box>)}
        </Stack>
      </WithIcon>

      <Flex height="100%" alignItems="flex-end">
        <Box>{/* @TODO show objects */}</Box>
      </Flex>

      <Flex height="100%" alignItems="flex-end">
        <Box>{/* @TODO show amount of policies */}</Box>
      </Flex>

      <OpenSvg
        css={css({ fill: 'primary', flexShrink: '0' })}
        width="1.5rem"
        height="1.5rem"
      />
    </RowContainer>
  );
};
